import { maninak } from './factory.js'

export default maninak
